import { apiSlice } from "../../app/api/apiSlice";

export const relockPolicyApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		relockPolicy: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/get_ob_re_lock_policy/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useRelockPolicyMutation } = relockPolicyApiSlice;

